"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.HandsModelToJSON = exports.HandsModelFromJSONTyped = exports.HandsModelFromJSON = void 0;
const runtime_1 = require("../runtime");
const _1 = require("./");
function HandsModelFromJSON(json) {
    return HandsModelFromJSONTyped(json, false);
}
exports.HandsModelFromJSON = HandsModelFromJSON;
function HandsModelFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'left': !runtime_1.exists(json, 'left') ? undefined : _1.HandModelFromJSON(json['left']),
        'right': !runtime_1.exists(json, 'right') ? undefined : _1.HandModelFromJSON(json['right']),
        'thumbs': !runtime_1.exists(json, 'thumbs') ? undefined : _1.FingerprintModelFromJSON(json['thumbs']),
    };
}
exports.HandsModelFromJSONTyped = HandsModelFromJSONTyped;
function HandsModelToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'left': _1.HandModelToJSON(value.left),
        'right': _1.HandModelToJSON(value.right),
        'thumbs': _1.FingerprintModelToJSON(value.thumbs),
    };
}
exports.HandsModelToJSON = HandsModelToJSON;
//# sourceMappingURL=HandsModel.js.map